import { Box, Button  } from "@shopify/polaris";
import React from "react";
import "./index.css";
import FourthCouponEventModal from "../FourthCouponEvent";
const Index = ({handleSelect,listData,setListData,handleGetList,handleTabChange}) => {

  return (
      <Box>
        <Box className="fourth_coupon_banner " style={{backgroundImage:'url(/sub/sub_top_fourth_coupon_banner.png)',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <Box>
          <Box className="fourth_coupon_content" style={{flex:1}}>
          <p><span><strong>4th</strong> Anniversary:</span> <span><strong>$40</strong> {'Coupons for everyone'}</span></p>
          </Box>
          <p className="fourth_coupon_content_time">
          <img src="/sub/time.png" alt="Dropshipman" />
          <span>
          Valid: July 20 to August 20, 2024
          </span>
          </p>
          </Box>
          <Button onClick={()=>{handleGetList(true)}}>Claim Coupons</Button>
        </Box>
        <FourthCouponEventModal listData={listData} setListData={setListData} handleTabChange={handleTabChange} handleSelect={handleSelect}/>
      </Box>
  );
};

export default Index;
